import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ques-host]',
  standalone: false
})
export class QuesDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
